import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "./plugins";
import store from "./store";
import { sync } from "vuex-router-sync";
import axios from "axios";

import "@/services/apiClient";
import { logAppVersion } from "@/util/appInfo";

logAppVersion("APP LOADED");

const apiBase = process.env.VUE_APP_API_BASE_URL || "http://localhost:8000";
axios.defaults.baseURL = apiBase + "/api/";
localStorage.setItem("apiBaseURL", apiBase);
Vue.config.productionTip = false;

sync(store, router);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
